var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49934 11.75C1.4008 11.7504 1.30316 11.7312 1.21215 11.6934C1.12113 11.6557 1.03858 11.6001 0.96934 11.53C0.82889 11.3893 0.75 11.1987 0.75 11C0.75 10.8012 0.82889 10.6106 0.96934 10.47L5.43934 5.99997L0.96934 1.52997C0.83686 1.38779 0.764736 1.19975 0.768165 1.00545C0.771593 0.811145 0.850306 0.62576 0.987719 0.488347C1.12513 0.350934 1.31052 0.272222 1.50482 0.268794C1.69912 0.265365 1.88716 0.337488 2.02934 0.469968L7.02934 5.46997C7.16979 5.61059 7.24868 5.80122 7.24868 5.99997C7.24868 6.19872 7.16979 6.38934 7.02934 6.52997L2.02934 11.53C1.9601 11.6001 1.87755 11.6557 1.78653 11.6934C1.69552 11.7312 1.59788 11.7504 1.49934 11.75Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.daa4f06c23e168f0d282d631df3c8702.svg";
export { ForwardRef as ReactComponent };